import { Fragment } from 'react'

function AvatarImage(props) {
    return (
        <Fragment>
            <img alt="profile avatar" src={props.image} className="ring-4 ring-teal-400 w-56 h-auto rounded-full shadow-xl"/>
        </Fragment>
    )
}

function PlayerImages({ images }) {
    return (
        <div className="flex justify-end sm:justify-start lg:justify-end xl:justify-start -space-x-2">
            {images ? images.slice(0,5).map((image) => (
            <img src={image} alt="players in the game" className="ring-2 ring-white w-8 h-8 rounded-full shadow-xl"/>
            )): null}
            <div className="flex justify-center items-center ring-2 ring-white w-8 h-8 rounded-full text-blueGray-600 bg-emerald-400 shadow-xl font-bold">
                +{images.length - 5}
            </div>
        </div>
    )
}

export { AvatarImage, PlayerImages }